const updateProductServiceBanner = (banner) => {
  if (!banner || !window.sessionStorage) {
    return;
  }

  const rawPayload = window.sessionStorage.getItem("lgcSelectedPricingTier");

  if (!rawPayload) {
    return;
  }

  let payload;

  try {
    payload = JSON.parse(rawPayload);
  } catch (error) {
    window.sessionStorage.removeItem("lgcSelectedPricingTier");
    return;
  }

  const currentPath = window.location.pathname;
  const payloadPath = payload.targetUrl ? new URL(payload.targetUrl, window.location.origin).pathname : "";

  if (payloadPath && payloadPath !== currentPath) {
    return;
  }

  const title = banner.querySelector("[data-product-service-banner-title]");
  const icons = banner.querySelector("[data-product-service-banner-icons]");
  const estimatedDays = banner.querySelector("[data-product-service-banner-estimated-days]");
  const maxValue = banner.querySelector("[data-product-service-banner-max-value]");
  const minCards = banner.querySelector("[data-product-service-banner-min-cards]");
  const insurancePrice = banner.querySelector("[data-product-service-banner-insurance-price]");
  const discount = banner.querySelector("[data-product-service-banner-discount]");
  const tcgIconUrl = banner.dataset.tcgIconUrl;
  const sportsIconUrl = banner.dataset.sportsIconUrl;
  const currencySuffix = banner.dataset.currencySuffix || "KR";

  if (title && payload.title) {
    title.textContent = payload.title;
  }

  const statMap = [
    {
      element: estimatedDays,
      value: payload.estimatedDays,
      formatter: (statValue) => statValue,
      statName: "estimated-days",
    },
    {
      element: maxValue,
      value: payload.maxValue,
      // Stored in DKK on the pricing card; shown in the active market currency
      formatter: (statValue) => `${window.lgcConvertDkk ? window.lgcConvertDkk(statValue) : statValue} ${currencySuffix}`,
      statName: "max-value",
    },
    {
      element: minCards,
      value: payload.minCards,
      formatter: (statValue) => statValue,
      statName: "min-cards",
    },
    {
      element: insurancePrice,
      value: payload.insurancePrice,
      formatter: (statValue) => statValue,
      statName: "insurance-price",
    },
    {
      element: discount,
      value: payload.discount,
      formatter: (statValue) => statValue,
      statName: "discount",
    },
  ];

  statMap.forEach(({ element, value, formatter, statName }) => {
    const statContainer = banner.querySelector(`[data-product-service-banner-stat="${statName}"]`);

    if (!element || !statContainer) {
      return;
    }

    if (value) {
      element.textContent = formatter(value);
      statContainer.classList.remove("product-service-banner-stat-hidden");
    } else {
      element.textContent = "";
      statContainer.classList.add("product-service-banner-stat-hidden");
    }
  });

  if (icons) {
    const iconMarkup = [];

    if (payload.includesTcg && tcgIconUrl) {
      iconMarkup.push(
        `<img src="${tcgIconUrl}" alt="Trading Card Games" class="product-service-banner-icon" width="32" height="32">`
      );
    }

    if (payload.includesSports && sportsIconUrl) {
      iconMarkup.push(
        `<img src="${sportsIconUrl}" alt="Sports Cards" class="product-service-banner-icon" width="32" height="32">`
      );
    }

    if (iconMarkup.length > 0) {
      icons.innerHTML = iconMarkup.join("");
    }
  }

  banner.classList.remove("product-service-banner-hidden");
};

const initProductServiceBanner = (scope = document) => {
  scope.querySelectorAll("[data-product-service-banner]").forEach((banner) => {
    updateProductServiceBanner(banner);
  });
};

const refreshAllProductServiceBanners = () => {
  initProductServiceBanner(document);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initProductServiceBanner(document));
} else {
  initProductServiceBanner(document);
}

document.addEventListener("shopify:section:load", (event) => {
  initProductServiceBanner(event.target);
});

window.addEventListener("storage", (event) => {
  if (event.key !== "lgcSelectedPricingTier") {
    return;
  }

  refreshAllProductServiceBanners();
});

document.addEventListener("lgc:pricing-tier-change", () => {
  refreshAllProductServiceBanners();
});
